import { httpClient } from "../../util/Api";
import moment from "moment";
import Swal from "sweetalert2";
import { number } from "prop-types";

export const randomNumberUsers = () => {
  const min = 2;
  const max = 80;
  // Generar un número aleatorio en el rango especificado
  const numeroAleatorio = Math.floor(Math.random() * (max - min + 1)) + min;

  return numeroAleatorio;
};


export const showLoadingModal = () => {
  Swal.fire({
    title: 'Cargando...',
    text: 'Por favor, espera un momento..',
    icon: 'info',
    allowOutsideClick: false,
    allowEscapeKey: false,
    focusConfirm: false,
    showConfirmButton: false, // Ocultar el botón de confirmación
    showCloseButton: false,
    didOpen: () => {
      Swal.showLoading(); // Mostrar el ícono de carga
    }
  });
};

export const hideLoadingModal = () => {
  Swal.close(); // Cierra el modal de carga de SweetAlert2
};

export const generateToken = async () => {
  await httpClient
    .get(`login?loginName=portal.serviapoyo&password=Impel2024*.&output=json`, {
      mode: "no-cors",
    })
    .then(async ({ data }) => {
      if (data.status === "ok") {
        localStorage.setItem("token", data.sessionId);
      }
    })
    .catch(function (error) {
      console.log('Error: ', error);
    });
};

export const validToken = async () => {
  // Obtener el valor almacenado en localStorage para la clave "token"
  const token = localStorage.getItem("token");
  try {
    if (!token) {
      console.log('El token no está definido o está vacío');
      await generateToken();
      return true;
    } else {
      console.log('El token existe en el almacenamiento local:', token);
      return false;
    }
    // Realizar acciones con la URL generada...
  } catch (error) {
    console.error('Error al obtener la Token:', error);
    return false;
  }
}


export const get_client = async () => {
  const token = localStorage.getItem("token");
  const id_client = localStorage.getItem("idClient");

  try {
    let query = encodeURI(
      `SELECT Url_Logo,Nombre,Num_Documento,Telefono,streetAddr1 FROM Cliente1 WHERE  id = ${id_client}`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const values = data[0];
      return {
        logo: values[0],
        name: values[1],
        document: values[2],
        phone: values[3],
        address: values[4],
      };
    } else {
      return {};
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getInfoClient = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT name,Num_Documento,Telefono,streetAddr1,email,Logo_URL FROM Cliente1 WHERE id=${idClient}`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return {
          rSocial: value[0],
          nit: value[1],
          phone: value[2],
          address: value[3],
          mail: value[4],
          logo: value[5]
        };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getListExams = async (idClient) => {
  const token = localStorage.getItem("token");
  const idRol = localStorage.getItem('idRol');
  const nameUser = localStorage.getItem('name');
  const idUser = localStorage.getItem('idUser');
  const idsCentros = (localStorage.getItem('idsCentros') || '').trim();
  let query = "";
  // Los procesos antiguos solo tienen el nombre en Creado_Por, los nuevos tambien traen el id en R90777674
  const createdByFilter = idUser
    ? `(Creado_Por = '${nameUser}' OR R90777674 = ${idUser})`
    : `Creado_Por = '${nameUser}'`;
  try {
    if (idRol == '53704614') {
      query = encodeURIComponent(
        `SELECT id,name,Empresa_Solicitante,Nombre_Completo,Numero_Documento,dateResquest,Cargo_Candidato,Tipo_Servicio,Estado_txt,Creado_Por,createdAt,Etiqueta#value,Url_Informe,nameCenter FROM Proceso3 WHERE R54405007 IN (${idClient}) AND createdAt >= '2024-11-01' AND ${createdByFilter} ORDER BY createdAt DESC`
      );
    } else if (idRol == '84087832' && idsCentros) {
      query = encodeURIComponent(
        `SELECT id,name,Empresa_Solicitante,Nombre_Completo,Numero_Documento,dateResquest,Cargo_Candidato,Tipo_Servicio,Estado_txt,Creado_Por,createdAt,Etiqueta#value,Url_Informe,nameCenter FROM Proceso3 WHERE R54405007 IN (${idClient}) AND R54446926 IN (${idsCentros}) AND createdAt >= '2024-11-01' ORDER BY createdAt DESC`
      );
    } else {
      query = encodeURIComponent(
        `SELECT id,name,Empresa_Solicitante,Nombre_Completo,Numero_Documento,dateResquest,Cargo_Candidato,Tipo_Servicio,Estado_txt,Creado_Por,createdAt,Etiqueta#value,Url_Informe,nameCenter FROM Proceso3 WHERE R54405007 IN (${idClient}) AND createdAt >= '2024-11-01' ORDER BY createdAt DESC`
      );
    }
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=10000000&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return {
          id: value[0],
          idIntegration: value[1],
          company: value[2],
          name: value[3],
          numDoc: value[4],
          dateRequest: value[5],
          rol: value[6],
          typeService: value[7],
          status: value[8] == '' || !value[8] ? 'SIN ESTADO' : value[8],
          createdBy: value[9],
          createdAt: value[10],
          label: value[11],
          report: value[12],
          costCenter: value[13],
        };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};
export const getInfoProcess = async (idProc) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURIComponent(
      "SELECT Estado_txt,Etiqueta#value,Numero_Documento,Url_Informe,Nombre_Completo,Fecha_Esperada_Visita,Fecha_Visita,Tipo_Servicio,Fecha_Reprogramada,urlAnexo,Documentos_Enviados " + `FROM Proceso3 WHERE id=${idProc}`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      let value = data[0];
      return {
        status: value[0],
        label: value[1] == '' ? 'Sin Etiqueta' : value[1],
        numDoc: value[2],
        urlReport: value[3],
        name: value[4],
        dateVisit: value[5],
        datePolig: value[6],
        type: value[7],
        dateRepro: value[8],
        urlAx: value[9],
        sendDocs: value[10],
      };
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};
export const getDocsProcess = async (idProc) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURIComponent(
      "SELECT Urls_Docs FROM Proceso3 WHERE id=" + idProc);
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`
    );

    if (data && data.length > 0) {
      const urlsDocs = data[0][0]; // Suponiendo que 'Urls_Docs' es el campo que contiene la cadena JSON
      if (urlsDocs) {
        const parsedUrlsDocs = JSON.parse(urlsDocs); // Convertir la cadena JSON a un objeto
        const final_data = parsedUrlsDocs.map((doc) => {
          return {
            url: doc.url,
            title: doc.title
          };
        });
        return final_data;
      } else {
        return [];
      }
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getProgressProcess = async (idProc) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURIComponent(
      "SELECT Fecha,Comentario,Nombre_Usuario " + `FROM Avance WHERE R54919864=${idProc} ORDER BY Fecha DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=100&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return {
          date: value[0],
          comment: value[1],
          nameUser: value[2],
        };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getTypeDocs = async () => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await httpClient.get(
      `getPicklist?objName=Candidato&fieldName=Tipo_Documento&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => ({
        value: value.id,
        label: value.name,
        code: value.code,
      }));
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getGendersPerson = async () => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await httpClient.get(
      `getPicklist?objName=Candidato&fieldName=_Genero&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => ({
        value: value.id,
        label: value.name,
        code: value.code,
      }));
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getCitys = async () => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,Nombre FROM Ciudad`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=100000&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getClientProfiles = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name FROM Perfil1 WHERE R16453592 = ${idClient}`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=300&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getClassExams = async () => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name FROM Clase_Examen`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    console.log("información data", data);
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getClassExamsFilter = async () => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name FROM Clase_Examen`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    console.log("información data", data);
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], text: value[1] };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getCitysFilter = async () => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,Nombre FROM Ciudad`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=700&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], text: value[1] };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getCandidatos = async (numDoc, name, idClient) => {
  const token = localStorage.getItem("token");
  console.log(numDoc + " " + name);
  var query = null;
  try {
    if (numDoc) {
      query = encodeURI(
        `SELECT id,name FROM Candidato WHERE Numero_Documento = ${numDoc} AND R15039866 IN (${idClient}) ORDER BY createdAt DESC`
      );
    } if (name) {
      query = encodeURI(
        `SELECT id,name FROM Candidato WHERE name LIKE ('%${name}%') AND R15039866 IN (${idClient})} ORDER BY createdAt DESC`
      );
    }
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getTypeExams = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error('No se encontró el token en el almacenamiento local');
    }
    const query = encodeURI(`SELECT id,name,R15040339 FROM Tipo_Examen`);
    const response = await httpClient.get(`/selectQuery?maxRows=99999999&query=${query}&sessionId=${token}&output=json`);
    const data = response.data;
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1], idClass: value[2] };
      });
      return final_data;
    } else {
      throw new Error('No se encontraron tipos de exámenes');
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getTypeExamsFilter = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error('No se encontró el token en el almacenamiento local');
    }
    const query = encodeURI(`SELECT id,name FROM Tipo_Examen`);
    const response = await httpClient.get(`/selectQuery?maxRows=99999999&query=${query}&sessionId=${token}&output=json`);
    const data = response.data;
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], text: value[1] };
      });
      return final_data;
    } else {
      throw new Error('No se encontraron tipos de exámenes');
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const createCandidato = async (values) => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await httpClient.get(
      `/create2?output=json&useIds=true&objName=Candidato1&Nombre=${values?.name}&Apellidos=${values?.lastName}&Numero_Documento=${values?.numDoc}&Celular=${values?.cel}&email=${values?.mail}&R53705023=${values?.company}&R54275203=${values?.city}&R54269615=${values?.location}&Cargo=${values?.position}&sessionId=${token}&output=json`
    );
    if (data) {
      return data;
    } else {
      return null;
    }

  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const createProcess = async (values, idCandidate) => {
  const token = localStorage.getItem("token");
  const emailContact = localStorage.getItem("emailContact");
  const nameUser = localStorage.getItem("name");
  const idUser = localStorage.getItem("idUser");
  const currentDate = moment().format('DD/MM/YYYY hh:mm A');
  try {
    const { data } = await httpClient.get(
      `/create2?output=json&useIds=true&objName=Proceso3&R53704909=${idCandidate}&R54405007=${values?.company}&R53705341=${values?.typeService}&R54446926=${values?.ceco}&Cuenta_SAP=${values?.sap}&R54446917=${values?.sap}&Observaciones=${encodeURIComponent(values?.obs || '')}&Fecha_Hora_Solicitud=${currentDate}&Email_Usuario_Portal=${emailContact}&Creado_Por=${nameUser}&R90777674=${idUser}&Cargo_Candidato=${values?.position}&sessionId=${token}&output=json`
    );
    if (data) {
      return data;
    } else {
      return null;
    }

  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const createComment = async (comment, idProcess) => {
  const token = localStorage.getItem("token");
  const nameUser = localStorage.getItem("name");
  try {
    const { data } = await httpClient.get(
      `/create2?output=json&useIds=true&objName=Avance&Comentario=${comment}&Nombre_Usuario=${nameUser}&R54919864=${idProcess}&sessionId=${token}&output=json`
    );
    if (data) {
      return data;
    } else {
      return null;
    }

  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};
export const updateCandidato = async (values, idCandidate) => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await httpClient.get(
      `/updateRecord?output=json&useIds=true&objName=Candidato1&id=${idCandidate}&Nombre=${values?.name}&Apellidos=${values?.lastName}&Numero_Documento=${values?.numDoc}&Celular=${values?.cel}&email=${values?.mail}&R53705023=${values?.company}&R54275203=${values?.city}&R54269615=${values?.location}&sessionId=${token}&output=json`
    );
    if (data) {
      return data;
    } else {
      return null;
    }

  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const createExamsCandidato = async (values, idCandidato) => {
  const token = localStorage.getItem("token");
  const name = localStorage.getItem("name");
  try {
    const { data } = await httpClient.get(
      `/create2?output=json&useIds=true&objName=Examen&R15040769=${values?.classExam}&R15040778=${values?.typeExam}&R15040812=${idCandidato}&CreadoPorTxt=${name}&sessionId=${token}&output=json`
    );
    if (data) {
      return data;
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const sendDocRollBase = async (idCandidato, file) => {
  try {
    const token = localStorage.getItem("token");
    const id = idCandidato; // Record ID
    const objName = "Proceso3"; // Object integration name
    const fieldName = "Adjunto_Cliente"; // Field integration name
    const contentType = file?.type; // File content type
    const fileName = file?.name; // File name

    const formData = new FormData();

    // Convertir el archivo a base64
    const convertFileToBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(",")[1]); // Remover prefijo
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file); // Inicia la lectura
      });

    // Esperar la conversión
    const base64String = await convertFileToBase64(file);

    // Crear el FormData con los valores requeridos
    formData.append("id", id);
    formData.append("objName", objName);
    formData.append("fieldName", fieldName);
    formData.append("contentType", contentType);
    formData.append("fileName", fileName);
    formData.append("value", base64String); // Cadena base64 sin prefijo

    // Enviar la solicitud HTTP
    const { data } = await httpClient.post(
      `/setBinaryData?output=json&sessionId=${token}`,
      formData
    );
    console.log("Response:", data);
  } catch (error) {
    console.error("Error al enviar el archivo:", error);
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const listDays = async () => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(`SELECT Nombre,id FROM Dia_Semana ORDER BY Codigo ASC`);
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=7&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[1], label: value[0] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getGroupByConsultsClient = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT Year,Mes,COUNT(*) FROM Cita WHERE Cliente IN (${idClient}) GROUP BY Year,Mes`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { year: value[0], mes: value[1], cant: value[2] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getGroupByCandidatosClient = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT Year,Mes,COUNT(*) FROM Candidato1 WHERE R53705023 IN (${idClient}) GROUP BY Year,Mes ORDER BY Year DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { year: value[0], mes: value[1], cant: value[2] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getGroupByStatusConsults = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT Year,status,COUNT(*) FROM Cita WHERE Cliente IN (${idClient}) GROUP BY Year,status ORDER BY Year DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { year: value[0], status: value[1], cant: value[2] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getGroupByStatusExams = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT Year,Estado_txt,COUNT(*) FROM Proceso3 WHERE R54405007 IN (${idClient}) GROUP BY Year,Estado_txt ORDER BY Estado_txt DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { year: value[0], status: value[1] || 'SIN ETAPA', cant: value[2] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getGroupByResultExams = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT Year,Cargo_Candidato,COUNT(*) FROM Proceso3 WHERE R54405007 IN (${idClient}) GROUP BY Year,Cargo_Candidato ORDER BY Cargo_Candidato DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { year: value[0], result: value[1] || 'SIN CARGO', cant: value[2] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getGroupByClassExams = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT Year,Tipo_Servicio,COUNT(*) FROM Proceso3 WHERE R54405007 IN (${idClient}) GROUP BY Year,Tipo_Servicio ORDER BY Tipo_Servicio DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { year: value[0], classExam: value[1] || 'SIN TIPO SERVICIO', cant: value[2] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getListCandidatos = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    const query = encodeURI(
      `SELECT id,Numero_Documento,name,Localidad_txt,Estado_txt,createdAt,Creado_Por,Cliente_txt,Ciudad_txt,Cargo FROM Candidato1 WHERE R53705023 IN (${idClient}) ORDER BY createdAt DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=999999&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return {
          id: value[0],
          numDoc: value[1],
          name: value[2],
          rol: value[3],
          status: value[4],
          createdAt: value[5],
          createdBy: value[6],
          nameClient: value[7],
          city: value[8],
          position: value[9],
        };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getInfoCandidate = async (idCandidate) => {
  const token = localStorage.getItem("token");
  try {
    let query =
      "SELECT Nombre,Apellido,Tipo_Documento%23value,Numero_Documento,_Genero%23value,Cargo,Emails_Resultados,Email,Adjunto_Cliente,Celular,Telefono,Direccion,Barrio_,Ciudad_txt,Estado_txt" + ` FROM Candidato WHERE id=${idCandidate}`
      ;
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      let value = data[0];
      return {
        name: value[0],
        lastName: value[1],
        typeDoc: value[2],
        numDoc: value[3],
        gender: value[4],
        profile: value[5],
        mailResults: value[6],
        mail: value[7],
        attach: value[8],
        cel: value[9],
        cel2: value[10],
        address: value[11],
        zone: value[12],
        city: value[13],
        status: value[14],
      };
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};


export const getDocsCandidate = async (idCandidate) => {
  const token = localStorage.getItem("token");
  try {
    let query =
      "SELECT id,Tipo_de_Documento%23value,Estado_txt,DocumentoURL " + `FROM Documento2 WHERE R15062019=${idCandidate} AND status=15117482 ORDER BY createdAt DESC`;
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1000000&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return {
          id: value[0],
          typeDoc: value[1],
          stateDoc: value[2],
          urlDoc: value[3]
        };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};


export const getListExamsCandidate = async (idCandidate) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,cliente_txt,Candidatotxt,Num_Documento,Claseexamentxt,TipoExamenTxt,Ciudad_txt,createdAt,CreadoPorTxt,Estado_txt,Resultado,R15040769,R15040778 FROM Examen WHERE R15040812=${idCandidate} AND Fecha >= '2024-11-01T00:00:00Z' ORDER BY createdAt DESC`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=10000000&query=${query}&sessionId=${token}&output=json`
    );
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return {
          id: value[0],
          client: value[1],
          candit: value[2],
          numDoc: value[3],
          classExam: value[4],
          typeExam: value[5],
          city: value[6],
          createdAt: value[7],
          createdBy: value[8],
          state: value[9],
          result: value[10] || 'SIN RESULTADO',
          idClassExam: value[11],
          idTypeExam: value[12]
        };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

//V2 SERVIAAPOYO

export const getCompanys = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name,Centros_de_Costos FROM Cliente1 WHERE id IN(${idClient})`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    console.log("información data", data);
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1], checkCecos: value[2] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getLocations = async (idCity) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name FROM Localidad1 WHERE R54269076 = ${idCity}`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    console.log("información data", data);
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getSaps = async (idCeco) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name FROM Cuenta_SAP WHERE R54268550 = ${idCeco}`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    console.log("información data", data);
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getCecos = async (idClient) => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name FROM Centro_Costo1 WHERE R54268671 = ${idClient}`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    console.log("información data", data);
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return [];
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getTypeServices = async () => {
  const token = localStorage.getItem("token");
  try {
    let query = encodeURI(
      `SELECT id,name FROM Tipo_Servicio1`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=9999999&query=${query}&sessionId=${token}&output=json`
    );
    console.log("información data", data);
    if (data.length > 0) {
      const final_data = data.map((value) => {
        return { value: value[0], label: value[1] };
      });
      return final_data;
    } else {
      return Promise.reject(data);
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getInfoCandidateByDoc = async (numDoc) => {
  const token = localStorage.getItem("token");
  try {
    let query = `SELECT id,Nombre,Apellidos,R54275203,R54269615,Celular,email FROM Candidato1 WHERE Numero_Documento = ${numDoc}`;
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`
    );
    if (data?.length > 0) {
      let value = data[0];
      return {
        id: value[0],
        name: value[1],
        lastName: value[2],
        idCity: value[3],
        idLocation: value[4],
        cel: value[5],
        email: value[6]
      };
    } else {
      return null;
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }
};

export const getAuthUser = async (user) => {
  const token = localStorage.getItem("token");
  const clearLoginStorage = () => {
    localStorage.removeItem("idUser");
    localStorage.removeItem("name");
    localStorage.removeItem("idClient");
    localStorage.removeItem("idClientContact");
    localStorage.removeItem("emailContact");
    localStorage.removeItem("idRol");
    localStorage.removeItem("idsCentros");
  };

  try {
    let query = encodeURI(
      `SELECT id,name,grupoIdsTxt,Rol,status,R14880980,email,idsCentros FROM Contacto WHERE Usuario_Portal = '${user?.email}' AND Password_Portal  = '${user?.password}'`
    );
    const { data } = await httpClient.get(
      `/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`
    );
    if (data?.length > 0) {
      let values = data[0];
      const isActiveUser = Number(values[4]) === 53675674;
      if (!isActiveUser) {
        clearLoginStorage();
        Swal.fire({
          icon: 'error',
          title: 'Usuario Inactivo',
          text: `El Usuario ${values[1]} no se encuentra activo.`,
        });
        return null;
      } else {
        localStorage.setItem("idUser", values[0]);
        localStorage.setItem("name", values[1]);
        localStorage.setItem("idClient", values[2]);
        localStorage.setItem("idClientContact", values[5]);
        localStorage.setItem("emailContact", values[6]);
        localStorage.setItem("idRol", values[3]);
        localStorage.setItem("idsCentros", values[7] || "");
      }
      return values;
    } else {
      clearLoginStorage();
      Swal.fire({
        icon: 'error',
        title: 'Usuario no encontrado',
        text: 'El Usuario no existe, valide el usuario y la contraseña!',
      });
      return null;
    }
  } catch (error) {
    httpClient.defaults.headers.common["Authorization"] = "";
    return Promise.reject(error);
  }

};
















